import { render, staticRenderFns } from "./AccountListItem.vue?vue&type=template&id=5672ae67&scoped=true"
import script from "./AccountListItem.vue?vue&type=script&lang=js"
export * from "./AccountListItem.vue?vue&type=script&lang=js"
import style0 from "./AccountListItem.vue?vue&type=style&index=0&id=5672ae67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5672ae67",
  null
  
)

export default component.exports